import React from 'react';
import { CORPORATE_CHEVRONDOWN, CORPORATE_CHEVRONUP, Icon } from '../../../../../icons';
import { SortMode } from '../../data-table.types';
export const DataTableSortIcon = ({ sortMode }) => {
    if (sortMode === SortMode.OFF) {
        return null;
    }
    if (sortMode === SortMode.ASC) {
        return React.createElement(Icon, { icon: CORPORATE_CHEVRONUP });
    }
    if (sortMode === SortMode.DESC) {
        return React.createElement(Icon, { icon: CORPORATE_CHEVRONDOWN });
    }
    return null;
};
//# sourceMappingURL=data-table-sort-icon.js.map